import styled from "styled-components";

export const Container = styled.main`
  margin-top: 10px;
  padding: 28px 16px 16px 16px;
  background-color: ${(props) => props.theme.white};

  hr {
    border-top: dotted 1px;
    margin-bottom: 16px;
  }
`;

export const SportCard = styled.div`
  display: flex;
  background-color: ${(props) => props.color};
  justify-content: center;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 8px;

  img {
    height: 64px;
  }
`;

export const BestOddsButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 10px;
  color: ${(props) => props.theme.white};
  cursor: pointer;
`;

export const BestOddsSelectorArrow = styled.div<{
  toggleShowBestOdds?: boolean;
}>`
  display: flex;
  transform: ${(props) => (props.toggleShowBestOdds ? "rotate(180deg)" : null)};
`;

export const StickyCompetitionFilter = styled.div`
  position: sticky;
  height: 60px;
  top: 60px;
  padding: 10px;
  background-color: ${(props) => props.theme.smalt};
  z-index: 99;
`;

export const StickyFiltersPanel = styled.div`
  position: sticky;
  z-index: 98;
  height: 60px;
  top: 120px;
  display: flex;
  flex-direction: row;
`;

export const DisplayContainer = styled.div<{
  display?: boolean;
}>`
  display: ${(props) => (props.display ? "block" : 'none')};
`;

export const ResultPanel = styled.div`
  margin: 10px;
`;

export const Page = styled.div<{ isLoading?: boolean }>`
  opacity: ${(props) => (props.isLoading ? 0.5 : 1.0)};
`;

export const PillFiltersPanel = styled.div`
  display: flex;
  align-items: center;
  margin: 12px;
  column-gap: 4px;
`;

export const PullToRefreshMessage = styled.div`
  text-align: center;
  font-size: 13px;
`;

export const FilterSubHeading = styled.div`
  padding: 0 0 12px 0;
  font-size: 16px;
  font-weight: 500;
`;
